import React from "react";
import EvalOrgChart from "../../components/user/evaluation/evaluationConsultList";
import Layout from "../../components/layouts/verticalLayout";

const EvalConsultOrgChartPage = (props) => {
  return <Layout body={<EvalOrgChart onlyOrgChart />} />;
};

EvalConsultOrgChartPage.propTypes = {};

export default EvalConsultOrgChartPage;
